export const casinos = [
  {
    id: 1,
    name: 'Flagman',
    rating: 4.9,
    logo: 'https://public.readdy.ai/ai/img_res/0910591892bee7e64b3c3e29c56d4778.jpg',
    liveGames: 'Blackjack VIP, Рулетка Immersive, Monopoly Live, Lightning Roulette',
    provider: 'Evolution Gaming, Pragmatic Play Live',
    link: 'https://flagmanway1.com/cc2db1682',
    badge: 'TOP',
    liveGamesCount: 250,
    minBet: '50₽',
    dealerLanguages: 'Русский, Английский',
    uniqueGames: 'Dream Catcher, Mega Ball, Crazy Time',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Бонус 100% до 50000₽ + 200 фриспинов'
  },
  {
    id: 2,
    name: 'Martin',
    rating: 4.8,
    logo: 'https://readdy.ai/api/search-image?query=elegant%20martini%20glass%20crown%20logo%20dark%20sophisticated%20casino%20emblem%20luxury%20brand%20identity%20modern%20minimalist&width=120&height=120&seq=martin-logo-002&orientation=squarish',
    liveGames: 'Baccarat VIP, Poker Texas Holdem, Roulette Pro, Speed Blackjack',
    provider: 'Evolution Gaming, Ezugi',
    link: 'https://martin-way-six.com/cade38d1c',
    badge: 'NEW',
    liveGamesCount: 220,
    minBet: '100₽',
    dealerLanguages: 'Русский, Английский, Немецкий',
    uniqueGames: 'Lightning Dice, Football Studio, Gonzo\'s Treasure Hunt',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Приветственный пакет до 100000₽ + кэшбэк 10%'
  },
  {
    id: 3,
    name: 'Beef',
    rating: 4.7,
    logo: 'https://readdy.ai/api/search-image?query=strong%20bull%20beef%20logo%20dark%20background%20premium%20casino%20brand%20powerful%20emblem%20modern%20design%20gold%20accents&width=120&height=120&seq=beef-logo-003&orientation=squarish',
    liveGames: 'Blackjack Party, Roulette Immersive, Baccarat Squeeze, Mega Wheel',
    provider: 'Pragmatic Play Live, Evolution Gaming',
    link: 'https://beef-way-three.com/c818d44d2',
    badge: '',
    liveGamesCount: 200,
    minBet: '50₽',
    dealerLanguages: 'Русский, Английский',
    uniqueGames: 'Sweet Bonanza Candyland, Mega Sic Bo',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Бонус 150% на первый депозит до 75000₽'
  },
  {
    id: 4,
    name: 'Fugu',
    rating: 4.8,
    logo: 'https://readdy.ai/api/search-image?query=japanese%20fugu%20fish%20elegant%20logo%20dark%20background%20luxury%20casino%20emblem%20oriental%20design%20gold%20details%20minimalist&width=120&height=120&seq=fugu-logo-004&orientation=squarish',
    liveGames: 'Lightning Roulette, Blackjack Infinite, Poker Caribbean, Dragon Tiger',
    provider: 'Evolution Gaming, Vivo Gaming',
    link: 'https://fugu-way-one.com/c763d5df9',
    badge: 'TOP',
    liveGamesCount: 230,
    minBet: '75₽',
    dealerLanguages: 'Русский, Английский, Японский',
    uniqueGames: 'Andar Bahar, Teen Patti, Sic Bo',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Бонус 200% до 100000₽ + эксклюзивные турниры'
  },
  {
    id: 5,
    name: 'SOL',
    rating: 4.6,
    logo: 'https://readdy.ai/api/search-image?query=bright%20sun%20sol%20logo%20golden%20rays%20dark%20background%20premium%20casino%20emblem%20modern%20luxury%20design%20minimalist&width=120&height=120&seq=sol-logo-005&orientation=squarish',
    liveGames: 'Roulette VIP, Blackjack Classic, Baccarat Pro, Monopoly Big Baller',
    provider: 'Pragmatic Play Live, Ezugi',
    link: 'https://sol-blsm10.com/c26114c36',
    badge: '',
    liveGamesCount: 180,
    minBet: '50₽',
    dealerLanguages: 'Русский, Английский',
    uniqueGames: 'Boom City, Cash or Crash',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Приветственный бонус 100% + 100 фриспинов'
  },
  {
    id: 6,
    name: 'LEX',
    rating: 4.7,
    logo: 'https://readdy.ai/api/search-image?query=modern%20lex%20letters%20logo%20geometric%20design%20dark%20background%20luxury%20casino%20emblem%20gold%20silver%20accents%20minimalist&width=120&height=120&seq=lex-logo-006&orientation=squarish',
    liveGames: 'Speed Roulette, Blackjack Fortune VIP, Poker Ultimate, Craps Live',
    provider: 'Evolution Gaming, Pragmatic Play Live',
    link: 'https://lexyway1.com/c737609d2',
    badge: 'NEW',
    liveGamesCount: 210,
    minBet: '100₽',
    dealerLanguages: 'Русский, Английский, Французский',
    uniqueGames: 'Deal or No Deal, Crazy Coin Flip',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Бонус 125% до 60000₽ + кэшбэк каждую неделю'
  },
  {
    id: 7,
    name: 'STARDA',
    rating: 4.8,
    logo: 'https://readdy.ai/api/search-image?query=bright%20star%20starda%20logo%20shining%20rays%20dark%20background%20premium%20casino%20emblem%20luxury%20modern%20design%20gold&width=120&height=120&seq=starda-logo-007&orientation=squarish',
    liveGames: 'Immersive Roulette 4K, Blackjack Platinum, Baccarat Control Squeeze, Mega Ball',
    provider: 'Evolution Gaming, Vivo Gaming',
    link: 'https://strd-blit10.com/c3369b683',
    badge: 'TOP',
    liveGamesCount: 240,
    minBet: '50₽',
    dealerLanguages: 'Русский, Английский, Испанский',
    uniqueGames: 'XXXtreme Lightning Roulette, First Person Games',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Бонус 175% на депозит до 90000₽ + VIP программа'
  },
  {
    id: 8,
    name: 'VOLNA',
    rating: 4.6,
    logo: 'https://readdy.ai/api/search-image?query=ocean%20wave%20volna%20logo%20flowing%20water%20dark%20background%20luxury%20casino%20emblem%20modern%20design%20blue%20gold%20accents&width=120&height=120&seq=volna-logo-008&orientation=squarish',
    liveGames: 'Roulette Russian, Blackjack Multihand, Poker Three Card, Sic Bo Live',
    provider: 'Pragmatic Play Live, Ezugi',
    link: 'https://vln-blrs.com/c6fd2926e',
    badge: '',
    liveGamesCount: 190,
    minBet: '75₽',
    dealerLanguages: 'Русский, Английский',
    uniqueGames: 'Snakes and Ladders Live, Mega Roulette',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Бонус 100% до 40000₽ + ежедневные турниры'
  },
  {
    id: 9,
    name: 'GIZBO',
    rating: 4.7,
    logo: 'https://readdy.ai/api/search-image?query=futuristic%20gizbo%20tech%20logo%20geometric%20shapes%20dark%20background%20premium%20casino%20emblem%20modern%20luxury%20design%20neon&width=120&height=120&seq=gizbo-logo-009&orientation=squarish',
    liveGames: 'Lightning Blackjack, Roulette Auto, Baccarat Speed, Crazy Time',
    provider: 'Evolution Gaming, Pragmatic Play Live',
    link: 'https://gizbo-way-seven.com/ce6052c2f',
    badge: 'NEW',
    liveGamesCount: 215,
    minBet: '50₽',
    dealerLanguages: 'Русский, Английский, Турецкий',
    uniqueGames: 'Adventures Beyond Wonderland, Funky Time',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Приветственный пакет до 80000₽ + 150 фриспинов'
  },
  {
    id: 10,
    name: 'IRWIN',
    rating: 4.8,
    logo: 'https://readdy.ai/api/search-image?query=elegant%20irwin%20crown%20logo%20royal%20emblem%20dark%20background%20luxury%20casino%20brand%20premium%20design%20gold%20details&width=120&height=120&seq=irwin-logo-010&orientation=squarish',
    liveGames: 'VIP Roulette Privée, Blackjack Grand, Baccarat Salon Privé, Monopoly Live',
    provider: 'Evolution Gaming, Ezugi',
    link: 'https://irwin-way-one.com/c372c38e2',
    badge: 'TOP',
    liveGamesCount: 260,
    minBet: '100₽',
    dealerLanguages: 'Русский, Английский, Итальянский',
    uniqueGames: 'Gold Vault Roulette, Lightning Storm',
    mobileStream: true,
    promoCode: 'R2D2',
    bonusDescription: 'Эксклюзивный бонус 250% до 150000₽ + персональный менеджер'
  }
];